export default {
  selectedClassState: state => state.selectedClass
}
